import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  cover: string;
  category: string;
  rating: number;
  views: string;
  chapters: number;
  status: string;
}

const categoryNames: Record<string, string> = {
  romance: '恋爱',
  fantasy: '奇幻',
  action: '动作',
  comedy: '搞笑',
  thriller: '悬疑',
  horror: '恐怖',
  drama: '剧情',
  daily: '日常',
};

export default function ComicCard({ id, title, cover, category, rating, views, chapters, status }: ComicCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <span className="inline-block px-2 py-0.5 text-xs bg-accent-500 text-background-50 rounded-md">
            {categoryNames[category] || category}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <div className="flex items-center gap-1 px-2 py-0.5 bg-foreground-950/60 backdrop-blur-sm rounded-md text-xs text-background-50">
            <i className="ri-star-fill text-accent-400 text-xs"></i>
            {rating}
          </div>
        </div>
        {status === '已完结' && (
          <div className="absolute top-2 left-2">
            <span className="px-1.5 py-0.5 text-xs bg-secondary-500 text-background-50 rounded-md">
              完结
            </span>
          </div>
        )}
      </div>
      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors truncate font-heading">
        {title}
      </h3>
      <div className="flex items-center justify-between mt-1.5">
        <span className="text-xs text-foreground-500">
          <i className="ri-eye-line mr-1"></i>{views}
        </span>
        <span className="text-xs text-foreground-500">
          共{chapters}话
        </span>
      </div>
    </Link>
  );
}